import { actionCreator } from '../../utils/actions';

export const lockDoorsClick = actionCreator('Device/LOCK_DOORS_CLICK');
export const ignitionClick = actionCreator('Device/TOGGLE_IGNITION_CLICK');
export const serviceModeClick = actionCreator('Device/TOGGLE_SERVICE_MODE');
export const setAutorunEngineDelayClick = actionCreator('Device/SET_AUTORUN_ENGINE_DELAY');
export const setWebastoPeriodClick = actionCreator('Device/SET_WEBASTO_PERIOD');
export const setWebasto = actionCreator('Device/SET_WEBASTO');
export const trunkClick = actionCreator('Device/TOGGLE_TRUNK');
export const filterRides = actionCreator('RidesSidebar/FILTER_JOURNEYS');
export const changeLanguage = actionCreator('Langs/CHANGE');

export const markAllEventsClick = actionCreator('Messages/MARK_ALL_CLICKED');



// WEBPACK FOOTER //
// ./src/components/Sidebar/actions.js